import { render, staticRenderFns } from "./RegisterLitterForm3.vue?vue&type=template&id=428f2554"
import script from "./RegisterLitterForm3.vue?vue&type=script&lang=ts"
export * from "./RegisterLitterForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports